function Calculator({ inputLabels, calculatorSettings, calculatorValues, setCalculatorValues }) {
  const onOptionChange = (e) => {
    const nextValue = e.target.value >= 0 ? e.target.value : "";
    setCalculatorValues({ ...calculatorValues, [e.target.dataset.sync]: nextValue });
  };

  const calculatorIdPrefix = useId();

  return (
    <>
      <div className="cost-comparison-tool__calculator">
        {Object.keys(calculatorSettings).map((key) => {
          return (
            <fieldset key={key} className="calculator-fieldset">
              <label className="calculator-label" htmlFor={`${calculatorIdPrefix}-${key}Input`}>
                {inputLabels[key]["input_label"]}
                {inputLabels[key]["input_description"] && (
                  <span class="calculator-tooltip" data-tooltip={inputLabels[key]["input_description"]}>
                    <i class="fa-regular fa-circle-info"></i>
                  </span>
                )}
              </label>
              <label
                className="calculator-label calculator-label--range"
                aria-label={`${inputLabels[key]["input_label"]} Range`}
              >
                <input
                  type="range"
                  className="calculator-input calculator-input--range"
                  name={`${key} Range`}
                  min={calculatorSettings[key]["minimum_value"]}
                  max={calculatorSettings[key]["maximum_value"]}
                  step={calculatorSettings[key]["step_value"]}
                  data-sync={key}
                  value={calculatorValues[key]}
                  onChange={onOptionChange}
                />
              </label>
              <span className="calculator-input__wrapper">
                <input
                  className="calculator-input calculator-input--number"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  type="number"
                  name={key}
                  data-sync={key}
                  value={calculatorValues[key]}
                  onChange={onOptionChange}
                  id={`${calculatorIdPrefix}-${key}Input`}
                />
                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path
                    d="M3.5415 12.7499H6.54484C6.63806 12.7504 6.73047 12.7326 6.81677 12.6973C6.90307 12.6621 6.98157 12.6101 7.04775 12.5445L11.9494 7.63572L13.9611 5.66655C14.0275 5.6007 14.0802 5.52236 14.1161 5.43604C14.1521 5.34973 14.1706 5.25714 14.1706 5.16364C14.1706 5.07013 14.1521 4.97754 14.1161 4.89123C14.0802 4.80491 14.0275 4.72657 13.9611 4.66072L10.9578 1.62197C10.8919 1.55558 10.8136 1.50288 10.7272 1.46692C10.6409 1.43096 10.5483 1.41245 10.4548 1.41245C10.3613 1.41245 10.2687 1.43096 10.1824 1.46692C10.0961 1.50288 10.0178 1.55558 9.95192 1.62197L7.95442 3.62655L3.03859 8.5353C2.97294 8.60149 2.921 8.67998 2.88575 8.76629C2.8505 8.85259 2.83263 8.945 2.83317 9.03822V12.0416C2.83317 12.2294 2.9078 12.4096 3.04064 12.5424C3.17347 12.6753 3.35364 12.7499 3.5415 12.7499ZM10.4548 3.12364L12.4594 5.12822L11.4536 6.13405L9.449 4.12947L10.4548 3.12364ZM4.24984 9.32864L8.45025 5.12822L10.4548 7.1328L6.25442 11.3332H4.24984V9.32864Z"
                    fill="#BD945B"
                  />
                </svg>
              </span>
            </fieldset>
          );
        })}
      </div>
    </>
  );
}
